export const isMacOs = () => /\smac\s/i.test(navigator.userAgent)
